
import axios from "axios";
import { defineComponent } from 'vue';

const CRISIS_NEWS_ENDPOINT = '/fileadmin/json/emergency_news.json';
const DEFAULT_LANGUAGE = 'EN';
const FETCH_DELAY = 400;

declare interface INewsItem {
    id: number,
    title: string,
    link: string
}

declare interface IResponse {
    [language: string]: INewsItem;
}

export default defineComponent({
    props: {
        action: {
            type: String,
            default: CRISIS_NEWS_ENDPOINT,
        },
        language: {
            type: String,
            default: DEFAULT_LANGUAGE,
        },
        label: {
            type: String,
            default: '',
        },
        linkLabel: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            news: [] as INewsItem[],
            isLoading: false
        }
    },
    mounted() {
        window.setTimeout(() => {
            this.fetchData();
        }, FETCH_DELAY);
    },
    beforeDestroy() {
        if (this.news.length) {
            window.removeEventListener('resize', this.updateEmergencyNewsHeight);
        }
    },
    methods: {
        updateEmergencyNewsHeight() {
            if (this.$root) {
                (this.$root as any).emergencyNewsHeight.value = Math.round(this.$el.offsetHeight);
            }
        },
        fetchData() {
            this.isLoading = true;
            axios.get(this.action)
                .then((response) => {
                    if (this.language in response.data) {
                        this.news = response.data[this.language];

                        window.addEventListener('resize', this.updateEmergencyNewsHeight);
                        this.$nextTick(this.updateEmergencyNewsHeight);
                    }
                })
                .catch((error) => {
                    console.log("Oops an error occurred.", error);
                })
                .then(() => {
                    this.isLoading = false;
                });
        }
    }
});
